import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Members from "../pages/members/Members";
import Events from "../pages/events/Events";
import Service from "../pages/service/Service";
import CreateService from '../pages/createService/CreateService'
import Vpc from "../pages/vpc/Vpc";
import ServiceIntegration from "../pages/serviceIntegration/ServiceIntegration";
import Billing from "../pages/billing/Billing";
import Setting from "../pages/setting/Setting";
import PrivateRoute from "./PrivateRoute";
import Login from "../pages/login/Login";
import Password from "../pages/password/Password";
import { useSelector } from "react-redux";
import PublicRoute from "./PublicRoute";
import ServiceOverview from "../pages/serviceOverview/ServiceOverview";

function Routing() {
  const user = useSelector((state) => state.AuthReducer.isUserLoggedIn);

  return (
    <div>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute isAllowed={user}>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/password"
            element={
              <PublicRoute isAllowed={user}>
                <Password />
              </PublicRoute>
            }
          />
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/"
              element={
                <PrivateRoute isAllowed={user}>
                  <Service />
                  {/* <ServiceOverview /> */}
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/create-new-services"
              element={
                <PrivateRoute isAllowed={user}>
                    <CreateService />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/events"
              element={
                <PrivateRoute isAllowed={user}>
                  <Events />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/members"
              element={
                <PrivateRoute isAllowed={user}>
                  <Members />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/vpc"
              element={
                <PrivateRoute isAllowed={user}>
                  <Vpc />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/service-integration"
              element={
                <PrivateRoute isAllowed={user}>
                  <ServiceIntegration />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/billing"
              element={
                <PrivateRoute isAllowed={user}>
                  <Billing />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/setting"
              element={
                <PrivateRoute isAllowed={user}>
                  <Setting />
                </PrivateRoute>
              }
            />
          </Route>
          <Route
            path="/"
            element={
              <PrivateRoute isAllowed={user}>
                <Sidebar />
              </PrivateRoute>
            }
          >
            <Route
              path="/:index/serviceOverview"
              element={
                <PrivateRoute isAllowed={user}>
                  <ServiceOverview />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default Routing;




